import {
  isDeferMachineBindingEnabled,
  isDeferRoleMaintenanceEnabled
} from './bootFeatureFlags';
import { recordCheckoutBlocked } from '../telemetry/bootTelemetry';

const roleListeners = new Set();
const financialListeners = new Set();

let roleMaintenanceDone = !isDeferRoleMaintenanceEnabled();
let machineBindingReady = !isDeferMachineBindingEnabled();
let machineBindingBlocked = false;

export function getRoleMaintenanceDone() {
  return roleMaintenanceDone;
}

export function markRoleMaintenanceDone() {
  if (roleMaintenanceDone) return;
  roleMaintenanceDone = true;
  roleListeners.forEach((listener) => listener(true));
  notifyFinancialOpsListeners();
}

export function subscribeRoleMaintenanceDone(listener) {
  roleListeners.add(listener);
  listener(roleMaintenanceDone);
  return () => roleListeners.delete(listener);
}

export function setMachineBindingState(ready, blocked = false) {
  machineBindingReady = ready;
  machineBindingBlocked = blocked;
  notifyFinancialOpsListeners();
}

export function isFinancialOpsReady() {
  return roleMaintenanceDone && machineBindingReady && !machineBindingBlocked;
}

export function subscribeFinancialOpsReady(listener) {
  financialListeners.add(listener);
  listener(isFinancialOpsReady());
  return () => financialListeners.delete(listener);
}

function notifyFinancialOpsListeners() {
  const ready = isFinancialOpsReady();
  financialListeners.forEach((listener) => listener(ready));
}

export function assertFinancialOpsReady() {
  if (isFinancialOpsReady()) return;
  recordCheckoutBlocked();
  throw new Error('FINANCIAL_OPS_NOT_READY');
}

export function resetStartupIntegritySignals() {
  roleMaintenanceDone = !isDeferRoleMaintenanceEnabled();
  machineBindingReady = !isDeferMachineBindingEnabled();
  machineBindingBlocked = false;
  roleListeners.forEach((listener) => listener(roleMaintenanceDone));
  notifyFinancialOpsListeners();
}
